<template src="./index.html"></template>

<script>
import data from './data.js';
export default {
	data() {
		return {};
	},
	created() {},
	mounted() {},
	methods: {
		forupdata(e) {
			window.open(e);
		}
	}
};
</script>

<style scoped lang="less">
@import url('index.less');
</style>
